import { EventTracker, Palette } from '@devexpress/dx-react-chart'
import { Chart, PieSeries, Tooltip } from '@devexpress/dx-react-chart-material-ui'
import { Box } from '@mui/material'
import { green, red } from '@mui/material/colors'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { pathOr } from 'ramda'
import React from 'react'

import Legend from './legend'

export type PieChartDatum = {
  legendLabel: string
  value: number
}

type Props = {
  data: PieChartDatum[]
  size?: number
  title?: string
}

const OverviewPieChart: React.FC<Props> = (props) => {
  const { title = 'Message Delivery Overview', data, size = 350 } = props

  const ChartTooltip = React.useCallback(
    ({ text, targetItem, ...restProps }: Tooltip.ContentProps) => {
      const legendLabel = `${pathOr(text, [targetItem.point, 'legendLabel'], data)} (${pathOr(
        text,
        [targetItem.point, 'value'],
        data,
      )})`
      return <Tooltip.Content {...restProps} text={legendLabel} targetItem={targetItem} />
    },
    [data],
  )

  return (
    <Paper>
      <Typography
        variant="h5"
        color="textSecondary"
        style={{
          textAlign: 'center',
          paddingTop: '20px',
          paddingBottom: '20px',
        }}
      >
        {title}
      </Typography>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Chart data={data} height={size} rotated width={size}>
          <Palette scheme={scheme} />
          <PieSeries argumentField="legendLabel" valueField="value" />
          <EventTracker />
          <Tooltip contentComponent={ChartTooltip} />
          <Legend />
        </Chart>
      </Box>
    </Paper>
  )
}

const scheme = [green.A700, '#2f80ac', red.A200]

export default OverviewPieChart
